<template>
    <div id="gamer-earnings">
      <div id="gamer-time">
        <div>IT WOULD TAKE <br>{{ selectedPlayer }}</div>
        <div class="highlight">{{ earningTime }}</div>
        <div>TO EARN YOUR SALARY</div>
      </div>
      <div id="gamer-total">
        SINCE YOU HAVE BEEN HERE {{ selectedPlayer }} HAS EARNED <br /><br />
        <div id="gamer-result">
          {{ selectedCurrency }}
          <span class="highlight">{{ totalEarning }}</span>
        </div>
      </div>
    </div>
</template>

<style lang="scss" scoped>

#gamer-earnings {
  max-width: 300px;
  height: 300px;
  margin: 40px;
}

#gamer-time {
  text-align: center;
  line-height: 30px;
}

#gamer-total {
  @extend #gamer-time;
  margin: 40px 0px 0px 0px;
}

#gamer-result {
  font-size: 40px;
}

.highlight {
  color: $yellow;
}
</style>

<script>
export default {

    computed: {
    selectedPlayer() {
      return this.$store.getters.getGamerData.gamerId;
    },
    earningTime() {
      var units = "mins"
      const mySalary = this.$store.getters.getMySalary;
      const currencyRate = this.$store.getters.getCurrencyRate;
      const earningPerMin = this.$store.getters.getGamerData.earningPerMin;
      var earnTime = mySalary/(earningPerMin*currencyRate);
      if (earnTime > 1440) {
            units = "days";
            earnTime=earnTime/1440;
      } else if 
      (earnTime > 60) {
            units = "hours";
            earnTime=earnTime/60;
      }

      earnTime = earnTime.toFixed(2);

      return earnTime.toString() + " " +units;

    },
    selectedCurrency() {
      return this.$store.getters.getCurrencySymbol;
    },
    totalEarning() {
      const earningRate = this.$store.getters.getGamerData.earningPerMin;
      const currencyRate = this.$store.getters.getCurrencyRate;
      var earnings = (earningRate/60) * currencyRate * this.$store.getters.getTime;
      return this.humanFormat(earnings.toFixed(2));
    },
  },
  methods: {
    humanFormat(profit) {
      return new Intl.NumberFormat().format(profit);
    },
  },
    
}
</script>